// import React from 'react';
// import { Row, Col, Form, Button } from 'react-bootstrap';
// import { useRecoilState } from 'recoil';
// import { addPocFormAtom } from '../../Services/_states';
// import SelectDropdown from '../Shared/SelectDropdown';

// export const AddPocForm = () => {
//   const [formData, setFormData] = useRecoilState(addPocFormAtom);

//   const removeField = (data, index) => {
//     const newState = [...formData.slice(0, index), ...formData.slice(index + 1)];
//     setFormData(newState);
//   };
//   const handleChange = (e, fieldName, index) => {
//     const { value } = e.target;
//     setFormData((prevFormData) => {
//       const updatedFormData = [...prevFormData];
//       updatedFormData[index] = {
//         ...updatedFormData[index],
//         [fieldName]: value,
//       };
//       return updatedFormData;
//     });
//   };

//   return (
//     <div>
//       {formData.map((item, index) => {
//         return (
//           <Row key={index}>
//             <Col sm={12} md={6} lg={4} xl={2}>
//               <Form.Group className="mb-3" controlId="POCPhoneNumber ">
//                 <Form.Label>
//                   Phone Number <span className="required-field">*</span>
//                 </Form.Label>
//                 <Form.Control
//                   type="number"
//                   placeholder="Phone Number"
//                   value={item?.mobile || ''}
//                   onChange={(e) => handleChange(e, 'mobile', index)}
//                 />
//               </Form.Group>
//             </Col>
//             <Col sm={12} md={6} lg={4} xl={3}>
//               <Form.Group className="mb-3" controlId="POCName ">
//                 <Form.Label>
//                   POC Name <span className="required-field">*</span>
//                 </Form.Label>
//                 <Form.Control
//                   type="text"
//                   placeholder="POC Name"
//                   value={item?.name || ''}
//                   onChange={(e) => handleChange(e, 'name', index)}
//                 />
//               </Form.Group>
//             </Col>
//             <Col sm={12} md={6} lg={4} xl={3}>
//               <Form.Group className="mb-3" controlId="AgencyUser">
//                 <Form.Label>
//                   Designation <span className="required-field">*</span>
//                 </Form.Label>
//                 <SelectDropdown
//                   optionsData={[]}
//                   placeholder="Select Designation"
//                   label="Select Designation"
//                   id="selectDesignation"
//                   OptionLabel={'supplier_name'}
//                   OptionValue={'supplier_id'}
//                   selectedValue={null}
//                   // handleSelect={getSupplierData}
//                 />
//               </Form.Group>
//             </Col>
//             <Col sm={12} md={6} lg={4} xl={2}>
//               <Form.Group className="mb-3" controlId="POCEmail">
//                 <Form.Label>
//                   Email <span className="required-field">*</span>
//                 </Form.Label>
//                 <Form.Control
//                   type="email"
//                   placeholder="Enter Email"
//                   value={item?.email || ''}
//                   onChange={(e) => handleChange(e, 'email', index)}
//                 />
//               </Form.Group>
//             </Col>
//             <Col sm={12} md={6} lg={4} xl={2} className='mt-4'>
//               <span
//                 style={{ cursor: 'pointer' }}
//                 onClick={(e) => {
//                   removeField(item, index);
//                 }}
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="20"
//                   height="20"
//                   fill="currentColor"
//                   className="bi bi-trash-fill"
//                   viewBox="0 0 16 16"
//                 >
//                   <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
//                 </svg>
//               </span>
//             </Col>
//           </Row>
//         );
//       })}
//       <Button
//         variant="primary"
//         onClick={(e) => {
//           setFormData([...formData, { contact_type: '', email: '', mobile: '', name: '' }]);
//         }}
//       >
//         +Add POC
//       </Button>
//     </div>
//   );
// };





import React from 'react';
import {
  Grid,
  TextField,
  IconButton,
  Tooltip,
  Button,
  Box,
  Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useRecoilState } from 'recoil';
import { addPocFormAtom } from '../../Services/_states/Intervene/intervene.js';
import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import PhoneNumberInput from '../Shared/PhoneNumber/PhoneNumberInput.tsx';

const AddPocForm: React.FC = () => {
  const [formData, setFormData] = useRecoilState(addPocFormAtom);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    fieldName: string,
    index: number
  ) => {
    const { value } = e.target;
    const updatedFormData = [...formData];
    updatedFormData[index] = { ...updatedFormData[index], [fieldName]: value };
    setFormData(updatedFormData);
  };

  const removeField = (index: number) => {
    const newState = formData.filter((_, i) => i !== index);
    setFormData(newState);
  };

  const addNewPOC = () => {
    setFormData([
      ...formData,
      { contact_type: '', email: '', mobile: '', name: '', designation: null },
    ]);
  };

  return (
    <Box>
      {formData.map((item, index) => (
        <Box key={index} sx={{ pt: index !== 0 ? 1 : 0 }}>
          <Grid container spacing={2} alignItems="center">
          {/* <Grid item xs={12} sm={6} md={4} lg={2}>
            <TextField
               label={
                  <Typography component="span">
                    Phone Number<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                  </Typography>
                }
              type="tel"
              fullWidth
              size='small'
           //   required
              value={item.mobile || ''}
              onChange={(e) => handleChange(e, 'mobile', index)}
            />
          </Grid> */}
          <Grid item xs={12} sm={6} md={4} lg={3}>
  <PhoneNumberInput
  value={{
    code: item.countryCode || '+91',
    number: item.mobile || '',
  }}
  onChange={(val) => {
    const updatedFormData = [...formData];
    updatedFormData[index] = {
      ...updatedFormData[index],
      countryCode: val.code,
      mobile: val.number,
    };
    setFormData(updatedFormData);
  }}
/>
</Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <TextField
               label={
                  <Typography component="span">
                    Poc Name<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                  </Typography>
                }
              fullWidth
              size='small'
             // required
              value={item.name || ''}
              onChange={(e) => handleChange(e, 'name', index)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <SearchableDropdown
              options={[]}
               label={
                  <Typography component="span">
                    Designation<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                  </Typography>
                }
              labelKey="supplier_name"
              valueKey="supplier_id"
              value={item.designation || null}
              onChange={(value) => {
                const updatedFormData = [...formData];
                updatedFormData[index] = { ...updatedFormData[index], designation: value };
                setFormData(updatedFormData);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <TextField
               label={
                  <Typography component="span">
                    Email<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                  </Typography>
                }
              type="email"
              size='small'
              fullWidth
              // required
              value={item.email || ''}
              onChange={(e) => handleChange(e, 'email', index)}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={2} display="flex" alignItems="center">
            {index === formData.length - 1 && (
              <Tooltip title="Add POC" arrow>
                <IconButton color="primary" onClick={addNewPOC}>
                  <AddIcon />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="Remove" arrow>
              <IconButton color="error" onClick={() => removeField(index)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>
      ))}
    </Box>
  );
};

export default AddPocForm;
